import React from 'react';
import {Flex} from "antd";
interface FilterItemsTitleProps {
  title: string,
  count: number
}

export default function FilterItemsTitle({title, count}: FilterItemsTitleProps) {
  return (
    <Flex className={'compare-filter__items-title'} gap={'small'} justify={'space-between'}>
      <Flex gap={'small'}>
        {title}
      </Flex>
      <Flex className={'compare-filter__items-title-count'} gap={'small'}>
        {count}
      </Flex>
    </Flex>
  )
}
